import React, { useState, useEffect } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"

import avatar2 from "../../assets/images/users/24X7RETAIL.png"
import profileImg from "../../assets/images/megamenu-img.png"

import Config, { ActiveClient } from "../../config";

const WelcomeComp = ({ dashboardData }) => {
  const [username, setusername] = useState("")
  const [company, setcompany] = useState("")
  const [location, setlocation] = useState("")
  const [usrImg, setusrImg] = useState(profileImg);
  const [userImage, setUserImage] = useState(true)

  useEffect(async () => {
    if (localStorage.getItem("authUser")) {

      const obj = JSON.parse(localStorage.getItem("authUser"))
      setusername(obj[0])
      setlocation(obj[4])
      setcompany(obj[6])
      setusrImg(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);
      setUserImage(obj[1])

      try {
        const response = await fetch(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);

        // Check if the response is ok (status code 200)
        if (!response.ok) {
          setUserImage(false)
        }
      } catch (error) {
      }
    }

  }, [])

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome to {Config[Config.ActiveClient].companyName}</h5>
                <p>{Config[Config.ActiveClient].companyName} Dashboard</p>
              </div>
            </Col>
            <Col xs="4" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="6">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={userImage ? usrImg : avatar2}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
            </Col>

          </Row>
          <Row>
            <Col sm="6">
              <h5 className="font-size-15 text-truncate">{username}</h5>
              <p className="text-muted mb-0 text-truncate">{company}</p>
            </Col>
            <Col sm="6">
              {String(location).length > 12 ? <h6 className="font-size-18">{location}</h6> : <h5 className="font-size-18">{location}</h5>}
              <p className="text-muted mb-0">Location</p>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment >
  )
}
export default WelcomeComp
